var Libraries = $.extend(false, BaseModule ,{
    api_route : 'libraries',	
	data : {
        module      : 'libraries',
        page        : 1,
        limit       : 20,
        order_by    : 'id:desc',
        view        : 'list'
    },
   save_order:function(){
        var module_name = this.data.module,
            module = this,
            selection = [];
        
        $('input[name="order_item_id[]"]').each(function(){
            selection.push($(this).val());
        });
        $.ajax({
            url : API + module.api_route + '/order',
            method:'POST',
            data:{ 
                order_item_id: selection 
            },
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');
            }
        });
        return false;
    },
	


    load_list_dialog:function(id,type){
		var module_name = this.data.module;
		var module = this;
		this.data.connection_id = id;
		this.data.connection_type = type;
		$("#"+module_name+"-dialog-list").on('shown.bs.modal', function () {
		  	$("#"+module_name+"-dialog-list .modal-body").html('<div class="'+module_name+'-form"></div><div class="'+module_name+'-list"><p>Loading. Please wait...</p></div>');
			module.load_list();
		}).on('hidden.bs.modal', function () {
		  	$("#"+module_name+"-dialog-list .modal-body").html('<div class="'+module_name+'-list"><p>Loading. Please wait...</p></div>');
		}).modal('show');
	},

    init:function(){
        "use strict";
        var module_name = this.data.module,module = this;
    }

});

$(document).ready(function(){
    "use strict";
	Libraries.init();
});

